<div class="nugget-container">
  <div
    class="nugget-content"
    [class.has-columns]="nugget().img && nugget().context"
    [class.order-reversed]="!nugget().imageOnTheLeft"
  >
    @if (nugget().img) {
      <div class="nugget-image">
        <img [src]="nugget().img | base64ToImage" [alt]="nugget().title" />
      </div>
    }
    @if (nugget().context || nugget().title) {
      <div class="nugget-text-wrapper">
        @if (nugget().title && nugget().context) {
          <h2 class="nugget-title">{{ nugget().title }}</h2>
        }
        @if (nugget().context) {
          <div class="nugget-text" [innerHTML]="nugget().context | safeHtml"></div>
        }
      </div>
    }
  </div>
  <div class="nugget-button-container">
    @if (nugget().buttonLink) {
      <a [href]="nugget().buttonLink" mat-raised-button color="primary" class="nugget-action">
        {{ nugget().buttonLabel }}
      </a>
    }
  </div>
</div>
